<template>
  <sui-page>
    <sui-page-header :pageId="contextPageId" />
    <sui-page-contents>
      <div class="comm_scr_wrap">
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_WRD_ID')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="textFieldWordId"
              v-model="queryData.wordId"
              maxlength="40"
              @keyup.enter="onClickSearch"
            />
          </div>
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_WRD_NM')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="textFieldWordName"
              v-model="queryData.wordName"
              maxlength="40"
              @keyup.enter="onClickSearch"
            />
          </div>
        </div>
        <div class="row">
          <div class="col-xs-1">
            <sui-input-label :label="$t('MSG_TXT_WRD_NATU_NM')" />
          </div>
          <div class="col-xs-5">
            <sui-text-field
              ref="textFieldWordNatureName"
              v-model="queryData.wordNatureName"
              maxlength="100"
              @keyup.enter="onClickSearch"
            />
          </div>
        </div>
        <div class="btn_wrap">
          <sui-button
            type="button"
            class="comm_btn_Reset"
            @click="onClickReset"
          >
            {{ $t("MSG_BTN_RESET") }}
          </sui-button>
          <sui-button
            v-permission:read="contextPageId"
            type="button"
            class="comm_btn_Scr"
            @click="onClickSearch"
          >
            {{ $t("MSG_BTN_SRCH") }}
          </sui-button>
        </div>
      </div>
      <div class="mrB30" />
      <sui-s-grid
        :headers="columnDictionary"
        :data-source="dsDictionary"
        :options="options"
        @grid:row-click="onSelectRow"
      >
        <template #right-info>
          <sui-button
            class="comm_btn_gridTop comm_ico_excel"
            @click="onClickExcelDownload"
          >
            {{ $t('MSG_BTN_EXCEL_DOWN') }}
          </sui-button>
        </template>
      </sui-s-grid>
      <div class="mrB30" />
      <sui-page-tab-box-type
        ref="tab"
        :tabItems="tabItems"
        :defaultTabIndex="defaultTabIndex"
        :setCurrentTabComponent="onSetCurrentTabComponent"
        @change-tab-idx="onChangeTabIdx"
      >
        <container
          :is="currentTabComponent"
          :selectedGridRowData="selectedGridRowData"
          @onClickSearch="onClickSearch"
        />
      </sui-page-tab-box-type>
    </sui-page-contents>
  </sui-page>
</template>

<script>
import { urDataSet } from 'uidev-component/index.js';
import BasePage from '~cm/components/BasePage';
import tab01 from './components/PGE_CMU_00017_T01.vue';


export default {
  name: 'PGE_CMU_00017', // eslint-disable-line vue/name-property-casing
  components: {
    tab01,
  },
  extends: BasePage,
  data() {
    return {
      dsDictionary: new urDataSet(),
      options: {
        multiSelect: false,
      },
      selectedGridRowData: {},
      tabItems: [
        {
          tabTitle: 'Dictionary',
          component: tab01,
        },
      ],
      currentTabComponent: 'tab01',
      defaultTabIndex: 0,
      queryData: {
        wordId: '',
        wordName: '',
        wordNatureName: '',
      },
    };
  },
  computed: {
  },
  watch: {},
  created() {
    this.columnDictionary = [
      {
        value: 'wordId',
        text: this.$t('MSG_TXT_WRD_ID'),
      },
      {
        value: 'wordName',
        text: this.$t('MSG_TXT_WRD_NM'),
      },
      {
        value: 'wordNatureName',
        text: this.$t('MSG_TXT_WRD_NATU_NM'),
      },
      {
        value: 'finalModificationUserId',
        text: this.$t('MSG_TXT_FNL_MDFC_USR_ID'),
        component: {
          props: ['row', 'value'],
          template:
            `<cmp-user-name-link
              :pageId="'PGE_CMU_00017'"
              :displayType="'1'"
              :displayLanguageId="row.finalModificationDisplayLangId"
              :userId="row.finalModificationUserId"
              :userName="row.finalModificationUserName"
              :userGlobalName="row.finalModificationUserGlobalName"
              :departmentName="row.finalModificationDepartmentName"
              :departmentEnglishName="row.finalModificationDepartmentEnglishName"
              :type="'link'"
            />`,
        },
      },
      {
        value: 'finalModificationDTM',
        text: this.$t('MSG_TXT_FNL_MDFC_DTM'),
        customValue(value, row) {
          return utils.dateformatToClient(value);
        },
      },
    ];
  },
  mounted() {
    this.$nextTick(() => {
      this.onLoad();
    });
  },
  beforeUpdate() {},
  updated() {},
  beforeDestroy() {},
  destroyed() {},
  methods: {
    onLoad() {
      const paramData = utils.getParameter(this, 'queryData');
      if (!utils.isEmpty(paramData)) {
        this.queryData = paramData;
        this.onClickSearch();
      }
    },
    onClickSearch() {
      const dataParams = {
        wordId: this.queryData.wordId,
        wordName: this.queryData.wordName,
        wordNatureName: this.queryData.wordNatureName,
      };
      http.requestTest('get', '/api/v1/common/dictionary', {
      // http.request(this.contextPageId, 'DTS_XXX_XXXXX', {
        query: dataParams,
      }).then(res => {
        this.dsDictionary.setData(res.data);
      });
    },
    onClickReset() {
      this.queryData.wordId = '';
      this.queryData.wordName = '';
      this.queryData.wordNatureName = '';
    },
    onSetCurrentTabComponent(component) {
      this.currentTabComponent = component;
    },
    onChangeTabIdx(idx) {
      this.currentTabComponent = this.tabItems[idx].component;
    },
    onClickExcelDownload() {
      const sPageId = this.contextPageId;
      const objGridColumns = this.columnDictionary;
      const objGridDataset = this.dsDictionary;
      const sToday = utils.now('YYYYMMDDHHmmss');
      // TODO: Change sExcelName prefix 'excel' to your proper objectName
      const sExcelName = `excel_${sToday}.xlsx`;
      utils.downloadGridToExcel(sPageId, objGridColumns, objGridDataset, sExcelName, {});
    },
    onSelectRow(row) {
      if (row) {
        this.selectedGridRowData = row;
      }
    },

  },
};
</script>

<style scoped>
</style>
